













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";

@Component
export default class CopyUrl extends Vue {
  get currentUrl(): string {
    return window.location.href;
  }

  onCopy(e: any) {
    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      queue: false,
      message: `クリップボードにコピーしました ${e.text}`,
    });
  }
  onError(e: any) {
    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      queue: false,
      message: `クリップボードへのコピーに失敗しました`,
    });
  }
}
